var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutImg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2796.04 2800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#bdd0fb;}.cls-4{opacity:0.3;}.cls-5{fill:#91b3fa;}.cls-22,.cls-6{fill:#2b69b3;}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:#18174a;}.cls-9{fill:url(#linear-gradient-3);}.cls-10{fill:url(#linear-gradient-4);}.cls-11{fill:url(#linear-gradient-5);}.cls-12{fill:url(#linear-gradient-6);}.cls-13{fill:url(#linear-gradient-7);}.cls-14{fill:url(#linear-gradient-8);}.cls-15{fill:url(#linear-gradient-9);}.cls-16{fill:url(#linear-gradient-10);}.cls-17{fill:url(#linear-gradient-11);}.cls-18{fill:url(#linear-gradient-12);}.cls-19{fill:url(#linear-gradient-13);}.cls-20,.cls-23,.cls-25,.cls-27{fill:#fff;}.cls-20{opacity:0.65;}.cls-21{fill:url(#linear-gradient-14);}.cls-22{opacity:0.7;}.cls-24{fill:url(#linear-gradient-15);}.cls-25{opacity:0.16;}.cls-26{opacity:0.68;}.cls-27{mix-blend-mode:soft-light;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2959.3,
    y1: 3162.64,
    x2: 902.62,
    y2: 942.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1215.65,
    y1: 2496.27,
    x2: 1321.99,
    y2: 2496.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1138.75,
    y1: 2594.4,
    x2: 1238.55,
    y2: 2594.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 486.31,
    y1: 1780.47,
    x2: 1460.82,
    y2: 1354.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1443.7,
    y1: 1443.54,
    x2: 1791.84,
    y2: 1443.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 376.61,
    y1: 1529.71,
    x2: 1351.11,
    y2: 1103.36,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 876.28,
    y1: 1143.63,
    x2: 1317.86,
    y2: 874.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 314.31,
    y1: 1387.33,
    x2: 1288.82,
    y2: 960.98,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 718.83,
    y1: 740.3,
    x2: 788.01,
    y2: 1217.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1330.11,
    y1: -711.84,
    x2: 1045.19,
    y2: -493.83,
    gradientTransform: "matrix(0.92, 0.39, -0.39, 0.92, -80.51, 928.2)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1294.77,
    y1: -758.03,
    x2: 1009.85,
    y2: -540.02,
    gradientTransform: "matrix(0.92, 0.39, -0.39, 0.92, -80.51, 928.2)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 954.01,
    y1: 1447.73,
    x2: 69.68,
    y2: 2984.44,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2313.59,
    y1: 2117.51,
    x2: 2552.14,
    y2: -130.97,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2468.82,
    y1: 2133.98,
    x2: 2707.37,
    y2: -114.5,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 2521.37,
    y1: 812.62,
    x2: 2442.06,
    y2: 1033.11,
    gradientTransform: "translate(3347.58 -1604.11) rotate(89.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2672.69,1897.6c-282.6,660.55-1028.58,944.27-1613.07,895.89-159.59-13.2-480.68-39.78-731.4-276.87C-153.26,2061.3-79.11,1109.55,381.81,549.21,441.16,477.06,852-6.41,1492.26.06,1961,4.8,2290,269.59,2330,302.58c50.53,41.67,162,140.7,262.46,297.8C2828.54,969.51,2849.29,1484.82,2672.69,1897.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1605.31,698.06c21.64-18.11,103.75-155.81,235.13,0,14.22,7.42,51-13.36,46.29-27.91-153.74-224.25-345.22-13.79-326.44,9.29S1580.14,719.13,1605.31,698.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1979.47,604.68c28.68-3.36,55.64-22.93,47.57-48-7.94-24.71-281.59-344.4-586.4,16a21.74,21.74,0,0,0,2.69,30.73c13.87,11.56,25.7,19.33,41,17.43C1763.28,304.55,1950.8,608,1979.47,604.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2121.93,509.17c20.37,4.08,62-11.23,51.25-44.69-481.69-524.1-910.67,25.22-894.93,47.37s47.64,23,60.48,15.51C1722.25,35.41,2101.56,505.09,2121.93,509.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1784.65,778.12a63.81,63.81,0,1,1-63.8-63.81A63.8,63.8,0,0,1,1784.65,778.12Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M736.62,229.17A10,10,0,0,1,722.86,226c-5.65-9.12-11.78-18.12-18.22-26.77a10,10,0,0,1,1.89-13.87l.15-.12a10,10,0,0,1,14,2.05c6.78,9.1,13.23,18.58,19.18,28.18a10,10,0,0,1-2.36,13.15A7.46,7.46,0,0,1,736.62,229.17ZM670.4,159.25c-7.55-7.68-15.51-15.11-23.65-22.09a10,10,0,0,1,13-15.18c8.57,7.35,16.94,15.17,24.89,23.25a10,10,0,0,1-.11,14.14,10.92,10.92,0,0,1-.9.78A10,10,0,0,1,670.4,159.25ZM604.56,105.8c-9-5.79-18.47-11.26-28-16.26a10,10,0,0,1,9.29-17.7c10,5.26,19.94,11,29.47,17.12a10,10,0,0,1,3,13.81,9.85,9.85,0,0,1-2.29,2.51A10,10,0,0,1,604.56,105.8ZM528.41,68.42c-10.13-3.63-20.53-6.86-30.93-9.6a10,10,0,0,1,5.11-19.33c10.94,2.89,21.89,6.29,32.55,10.1a10,10,0,1,1-6.73,18.83ZM445.83,48.93c-10.66-1.29-21.52-2.13-32.28-2.51a10,10,0,1,1,.7-20c11.33.4,22.76,1.29,34,2.64a10,10,0,1,1-2.39,19.85ZM361,48.2c-10.69,1.1-21.47,2.68-32,4.69a10,10,0,0,1-3.74-19.64c11.12-2.11,22.46-3.77,33.71-4.94A10,10,0,0,1,361,48.2ZM51.25,252.65a10,10,0,0,1-4.18-13.5c5.27-10,11-19.91,17.18-29.45a10,10,0,1,1,16.81,10.81c-5.81,9.05-11.3,18.46-16.31,28a10,10,0,0,1-13.5,4.18ZM278.17,66.28C268,69.73,257.85,73.67,248,78a10,10,0,0,1-8-18.31c10.36-4.54,21-8.69,31.76-12.33a10,10,0,1,1,6.43,18.93ZM98.42,179.42a10,10,0,0,1-1.06-14.1c7.38-8.57,15.22-16.93,23.31-24.86a10,10,0,1,1,14,14.28c-7.68,7.53-15.14,15.48-22.15,23.63a10,10,0,0,1-14.09,1Zm103.05-77c-9.14,5.64-18.16,11.75-26.8,18.16a10,10,0,0,1-12.08-15.92l.17-.13c9.1-6.75,18.59-13.18,28.2-19.12a10,10,0,0,1,11.39,16.4C202.07,102,201.77,102.22,201.47,102.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35.08,316.5a9.92,9.92,0,0,0,3.4-4.9c1.54-4.92,3.21-9.88,5-14.76a10,10,0,1,0-18.81-6.75c-1.84,5.13-3.6,10.35-5.22,15.53A10,10,0,0,0,35.08,316.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64.7,619.77a10,10,0,0,0,2.64-12.69c-2.48-4.52-4.9-9.17-7.19-13.81a10,10,0,1,0-17.92,8.86c2.42,4.89,5,9.78,7.57,14.54a10,10,0,0,0,13.56,4A10.33,10.33,0,0,0,64.7,619.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M628.66,752.83a10,10,0,1,1-11.45-16.38c8.61-6,17.1-12.51,25.33-19.34a10,10,0,0,1,12.77,15.38q-5.35,4.44-10.8,8.67C639.32,745.18,634,749.1,628.66,752.83Zm52-57.29a10,10,0,0,1-.61-14.12c7.16-7.81,14.07-16,20.53-24.36a10,10,0,1,1,15.81,12.22c-6.8,8.8-14.08,17.43-21.61,25.65a9.63,9.63,0,0,1-1.25,1.15A10,10,0,0,1,680.64,695.54ZM582,780.91c-9.9,5.07-20.15,9.79-30.47,14a10,10,0,1,1-7.57-18.5c9.8-4,19.53-8.49,28.93-13.3a10,10,0,0,1,10.69,16.79A10.58,10.58,0,0,1,582,780.91ZM733,627.69a10,10,0,0,1-3.7-13.64c5.27-9.18,10.2-18.69,14.67-28.27a10,10,0,1,1,18.12,8.44c-4.71,10.09-9.9,20.11-15.45,29.78a9.84,9.84,0,0,1-2.54,2.92A10,10,0,0,1,733,627.69ZM499.87,812c-10.76,2.77-21.8,5.11-32.79,7a10,10,0,1,1-3.33-19.71c10.45-1.77,20.93-4,31.15-6.62a10,10,0,1,1,5,19.36Zm-87,12.36c-11.13.34-22.41.22-33.52-.36a10,10,0,1,1,1.05-20c10.55.55,21.27.67,31.85.34a10,10,0,0,1,.62,20Zm-87.59-6.9c-10.95-2.08-21.94-4.66-32.65-7.64A10,10,0,0,1,298,790.59c10.18,2.84,20.61,5.28,31,7.27a10,10,0,1,1-3.74,19.63Zm-84-25.83c-10.23-4.43-20.39-9.35-30.19-14.63a10,10,0,0,1,9.46-17.6c9.31,5,19,9.68,28.67,13.89a10,10,0,0,1-7.94,18.34ZM165,748c-9-6.56-17.79-13.59-26.2-20.9A10,10,0,0,1,151.9,712c8,6.95,16.36,13.62,24.89,19.86a10,10,0,0,1,2.17,14,9.8,9.8,0,0,1-2,2A10,10,0,0,1,165,748ZM100.2,688.66c-5.4-6.16-10.69-12.56-15.7-19q-2.72-3.51-5.35-7.06a9.88,9.88,0,0,1,2.09-14,10,10,0,0,1,14,2.08c1.66,2.25,3.36,4.49,5.08,6.72,4.77,6.14,9.79,12.23,14.93,18.08a10,10,0,0,1-.92,14.11l-.48.39A10,10,0,0,1,100.2,688.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M778.33,548.09a10,10,0,0,0,3.43-5c1.59-5.17,3.1-10.48,4.49-15.76a10,10,0,1,0-19.32-5.1c-1.33,5-2.77,10.06-4.28,15a10,10,0,0,0,15.68,10.84Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M698.37,396.55a4.66,4.66,0,0,0-3-4.49l-53.26-19.88a248,248,0,0,0-28.81-74.89l26.16-50.44a4.68,4.68,0,0,0-.77-5.37l-47-49.41a4.67,4.67,0,0,0-5.33-1l-51.68,23.59A247.73,247.73,0,0,0,461.3,182.1l-17.18-54.2a4.66,4.66,0,0,0-4.33-3.25l-68.18-1.72a4.66,4.66,0,0,0-4.49,3l-19.88,53.27a247.64,247.64,0,0,0-74.89,28.81l-50.43-26.16a4.67,4.67,0,0,0-5.37.76l-49.42,47a4.67,4.67,0,0,0-1,5.32l23.6,51.69A247.44,247.44,0,0,0,157.16,360L103,377.18a4.67,4.67,0,0,0-3.26,4.34L98,449.69a4.67,4.67,0,0,0,3,4.49l53.27,19.88A247.44,247.44,0,0,0,183.11,549L157,599.39a4.66,4.66,0,0,0,.76,5.36l47,49.42a4.65,4.65,0,0,0,5.32,1l51.69-23.59a247.73,247.73,0,0,0,73.35,32.53l17.18,54.19a4.67,4.67,0,0,0,4.33,3.26l68.17,1.72a4.69,4.69,0,0,0,4.5-3L449.12,667A247.44,247.44,0,0,0,524,638.19l50.44,26.16a4.67,4.67,0,0,0,5.37-.76l49.41-47a4.67,4.67,0,0,0,1-5.32l-23.6-51.69a247.67,247.67,0,0,0,32.53-73.34l54.2-17.18a4.68,4.68,0,0,0,3.26-4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M431.83,482.84a68.5,68.5,0,1,1,8.38-5.56A67.65,67.65,0,0,1,431.83,482.84ZM347.56,409a52.56,52.56,0,1,0,24.83-31.65,53.45,53.45,0,0,0-6.5,4.31A52.23,52.23,0,0,0,347.56,409Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M499.76,556.39a172.39,172.39,0,0,0,13.13-11.29h0q2-1.89,3.93-3.85a169.86,169.86,0,0,0,17.36-20.66l.21-.3.6-.86c.39-.55.77-1.11,1.15-1.66a4,4,0,0,0-.14-4.7,3.73,3.73,0,0,0-.91-.86,4,4,0,0,0-5.55,1A160.74,160.74,0,0,1,357.87,578.7,160.52,160.52,0,0,1,286.1,306.62c64.18-61,166-58.45,227,5.7a160.52,160.52,0,0,1,40.33,75.42,4,4,0,1,0,7.8-1.75,168.52,168.52,0,0,0-42.33-79.18c-64.05-67.35-171-70-238.29-6A168.59,168.59,0,0,0,263.3,526a173,173,0,0,0,11.3,13.16,168.6,168.6,0,0,0,225.16,17.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1168.41,227.82a6.17,6.17,0,0,0,2-7.14c-1.91-4.88-4-9.76-6.2-14.52a6.17,6.17,0,1,0-11.2,5.19c2.1,4.53,4.09,9.19,5.91,13.84a6.18,6.18,0,0,0,8,3.5A6.34,6.34,0,0,0,1168.41,227.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1146.57,185.75a6.18,6.18,0,0,1-8.51-2,255.17,255.17,0,0,0-14.8-21.25c-1.11-1.44-2.25-2.86-3.4-4.28a6.18,6.18,0,0,1,.92-8.68,6.39,6.39,0,0,1,8.69.91q1.8,2.24,3.54,4.48a268.05,268.05,0,0,1,15.53,22.29,6.18,6.18,0,0,1-1.45,8.14A6,6,0,0,1,1146.57,185.75Zm-47.87-50.63a256.3,256.3,0,0,0-23.83-20.36,6.17,6.17,0,1,1,7.43-9.86,268.08,268.08,0,0,1,25,21.35,6.17,6.17,0,1,1-8.58,8.87Zm-50-37.62a252.06,252.06,0,0,0-28.11-13.89,6.18,6.18,0,0,1,4.78-11.39,266.12,266.12,0,0,1,29.47,14.57,6.16,6.16,0,0,1,2.29,8.42,6.26,6.26,0,0,1-1.57,1.81A6.18,6.18,0,0,1,1048.7,97.5ZM991,73.3a256,256,0,0,0-30.64-6.58,6.17,6.17,0,1,1,1.84-12.21,266.8,266.8,0,0,1,32.13,6.91A6.17,6.17,0,0,1,998.6,69a6.25,6.25,0,0,1-2.16,3.21A6.17,6.17,0,0,1,991,73.3Zm-61.87-9.37A257.9,257.9,0,0,0,897.79,65a6.17,6.17,0,1,1-1.16-12.29,268.35,268.35,0,0,1,32.83-1.11,6.17,6.17,0,0,1,3.6,11A6.08,6.08,0,0,1,929.12,63.93Zm-62.27,5.94a252.91,252.91,0,0,0-30.1,8.65,6.17,6.17,0,0,1-4.14-11.63,267.19,267.19,0,0,1,31.57-9.08,6.17,6.17,0,0,1,5.11,10.91A6.25,6.25,0,0,1,866.85,69.87Zm-58.91,21a255.6,255.6,0,0,0-27.07,15.79A6.17,6.17,0,0,1,774,96.37a267.76,267.76,0,0,1,28.38-16.56A6.17,6.17,0,0,1,809,90.2,5.77,5.77,0,0,1,807.94,90.84ZM724.8,148a6.17,6.17,0,0,1-.43-8.72,268.89,268.89,0,0,1,20.26-20.11c1.08-1,2.16-1.92,3.26-2.86a6.11,6.11,0,0,1,8.7.65,6.18,6.18,0,0,1-.64,8.71c-1,.88-2.05,1.77-3.07,2.7a254.14,254.14,0,0,0-19.36,19.19,6.18,6.18,0,0,1-8.72.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1082.51,531.08A268.48,268.48,0,0,1,1055.58,549a6.17,6.17,0,1,1-6.19-10.68,255.6,255.6,0,0,0,25.68-17,6.17,6.17,0,0,1,7.5,9.8Zm15.86-21.16a6.16,6.16,0,0,1,.17-8.72,257.78,257.78,0,0,0,20.9-22.69,6.17,6.17,0,0,1,9.56,7.81,270.55,270.55,0,0,1-21.9,23.77,5.37,5.37,0,0,1-.51.44A6.16,6.16,0,0,1,1098.37,509.92Zm-71.71,53.51a267.58,267.58,0,0,1-30.45,10.83,6.17,6.17,0,0,1-3.43-11.86,257.91,257.91,0,0,0,29.05-10.33,6.17,6.17,0,0,1,4.83,11.36ZM1139.36,462a6.19,6.19,0,0,1-1.94-8.52,254.13,254.13,0,0,0,14.8-27.05,6.18,6.18,0,0,1,11.18,5.25,264.54,264.54,0,0,1-15.53,28.38,5.94,5.94,0,0,1-1.44,1.59A6.2,6.2,0,0,1,1139.36,462ZM964.68,581.31a268.56,268.56,0,0,1-32.16,3.19,6.17,6.17,0,1,1-.47-12.34,254.19,254.19,0,0,0,30.67-3,6.17,6.17,0,0,1,4.76,11A6.07,6.07,0,0,1,964.68,581.31Zm-64.47,2.49a270.92,270.92,0,0,1-32-4.59,6.17,6.17,0,1,1,2.49-12.09,258.24,258.24,0,0,0,30.53,4.38,6.17,6.17,0,1,1-1,12.3Zm-63.22-13a266.05,266.05,0,0,1-30-12.14,6.17,6.17,0,1,1,5.32-11.14,253,253,0,0,0,28.58,11.57,6.19,6.19,0,0,1,3.89,7.82,6.19,6.19,0,0,1-7.82,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1173.36,404.3a6.18,6.18,0,0,0,2.08-2.95c1.65-5,3.15-10.12,4.48-15.14a6.18,6.18,0,0,0-12-3.14c-1.26,4.79-2.69,9.64-4.26,14.44a6.17,6.17,0,0,0,9.65,6.79Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1121.6,298.8a3.13,3.13,0,0,0-2-3l-35.64-13.3a165.89,165.89,0,0,0-19.28-50.11l17.5-33.75a3.12,3.12,0,0,0-.51-3.6L1050.19,162a3.1,3.1,0,0,0-3.56-.69l-34.58,15.79A165.53,165.53,0,0,0,963,155.3L951.47,119a3.13,3.13,0,0,0-2.9-2.18L903,115.71a3.12,3.12,0,0,0-3,2l-13.3,35.64a165.73,165.73,0,0,0-50.11,19.28l-33.75-17.51a3.13,3.13,0,0,0-3.59.51l-33.07,31.45a3.12,3.12,0,0,0-.69,3.56l15.79,34.59a165.78,165.78,0,0,0-21.77,49.08l-36.26,11.5a3.11,3.11,0,0,0-2.18,2.9l-1.15,45.62a3.12,3.12,0,0,0,2,3l35.65,13.3a165.61,165.61,0,0,0,19.27,50.11l-17.5,33.76a3.11,3.11,0,0,0,.51,3.59l31.45,33.07a3.12,3.12,0,0,0,3.56.68l34.59-15.78a165.81,165.81,0,0,0,49.08,21.77L890,514.12a3.12,3.12,0,0,0,2.9,2.18l45.62,1.15a3.15,3.15,0,0,0,3-2l13.3-35.64a165.47,165.47,0,0,0,50.11-19.28L1038.68,478a3.13,3.13,0,0,0,3.59-.51L1075.34,446a3.12,3.12,0,0,0,.69-3.56l-15.79-34.59A165.53,165.53,0,0,0,1082,358.81l36.27-11.49a3.15,3.15,0,0,0,2.18-2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M943.65,357.26a46.51,46.51,0,1,1,5.77-3.83A48.51,48.51,0,0,1,943.65,357.26ZM890.8,333.43a34.34,34.34,0,0,0,46.79,13.07h0a34.35,34.35,0,1,0-33.72-59.85,35.58,35.58,0,0,0-4.2,2.79A34.41,34.41,0,0,0,890.8,333.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M990.93,408.44a117.51,117.51,0,0,0,24.4-25.68l.6-.88a6.17,6.17,0,1,0-10.2-6.95,103.7,103.7,0,0,1-14.33,16.85h0c-.29.29-.59.56-.88.84a103,103,0,0,1-44.62,24.5,104.7,104.7,0,0,1-27.79,3.28h-.94a103.25,103.25,0,0,1-72.71-32.28,104.37,104.37,0,0,1-7-8.11,103.94,103.94,0,0,1,157.6-135.15,102.06,102.06,0,0,1,6.88,8,103.69,103.69,0,0,1,19.23,40.82,6.16,6.16,0,0,0,7.37,4.67,6.19,6.19,0,0,0,4.68-7.38,116.09,116.09,0,0,0-21.51-45.66,116.29,116.29,0,0,0-184,142.23q3.64,4.7,7.8,9.08A116.45,116.45,0,0,0,990.93,408.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 904.42,
    y: 2000.09,
    width: 60.47,
    height: 653.93,
    transform: "translate(1869.31 4654.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M669.85,2627.27h529.62a0,0,0,0,1,0,0v36.28a3.08,3.08,0,0,1-3.08,3.08H672.7a2.86,2.86,0,0,1-2.86-2.86v-36.51A0,0,0,0,1,669.85,2627.27Z",
    transform: "translate(1869.31 5293.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 569.69,
    y: 1844.37,
    width: 707.69,
    height: 200.71,
    rx: 69.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1271.46,2538.17s172.67,124.46,142.68,208.08c0,0-188.92-81.52-211.75-145.72s3.87-92.57,3.87-92.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1245.51,2433.86l-28.24,81.63c-4.26,12.31,0,26.34,11,33.3,5.52,3.49,13.06,6.71,23.37,9.05a33,33,0,0,0,36.55-16.59l33.78-63.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M970.74,1699.18s354.66,61.47,506.8,202S1337.9,2490,1337.9,2490s-47.8-.3-105.74-49.95c0,0,173-337.17,23.91-435.49-167.62-110.54-360.79-135.44-360.79-135.44l72-159.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1384.14,2700c-38-17.58-145.5-92.83-163.62-96.15s-49.56,18-49.56,18-7.65,13.76.53,37.74c25.24,30.54,81.27,88.75,156.6,110.44,55.41,16,94.17,1.08,118.31-16.32C1433.12,2733.45,1409.44,2711.71,1384.14,2700Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1328.09,2770c-75.33-21.69-131.36-79.9-156.6-110.44,5.53,16.21,18.27,37.09,45.51,61.57,67.53,60.7,196.53,82.58,224,78.37,22-3.38,19.94-23.7,5.41-45.82C1422.26,2771.08,1383.5,2786,1328.09,2770Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1138.75,2568.7c.43,10.46,21.82,46.35,34.31,66.48a32.6,32.6,0,0,0,27.61,15.45,83.81,83.81,0,0,0,22.81-2.75,21.14,21.14,0,0,0,14.21-26.31l-24.43-83.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M629.35,1592.73s-78.76,210.61,0,274.65S896,2003.54,938,2131.11s113.2,375.49,208.52,463.29c0,0,67-6.49,92-33.18,0,0-54.29-370.11-90.09-465.07-31-82.24-76.7-201-164.25-267.29-25.06-19-20.7-49.08-9.08-78.3l21.17-53.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1450.82,1427.66c-132.07,8-90.92-203-88.54-211.42l-200.44,141.58s10.61,112.83,177.26,172c42.17,15,80.7,15.64,114.77,8.32A182.33,182.33,0,0,1,1450.82,1427.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1706.18,1364.15c-49.22-34.23-105,0-105,0-65.8,43-114.48,61.34-150.39,63.51a182.33,182.33,0,0,0,3,110.49c73.72-15.85,126.45-69.2,149.37-96.57a23.8,23.8,0,0,1,33-3.61c10.25,8.09,20.2,19.17,18.39,30.84-3.55,23,23.13,30.3,25.14,22s-9.12-57.78-9.12-57.78,53.37,53.67,74.2,74.29,47,0,47,0S1755.39,1398.39,1706.18,1364.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M835,890.4s192.13-76.92,549.69,218.28c0,0,29.87,61.82-2.71,116.84s-343,323.14-385.7,471.83c0,0-185,60.1-376.23-82.41C620.07,1614.94,637,1201.13,835,890.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1214.84,821.75l-94.58,114.66a37.66,37.66,0,0,0-5,40.47c13.13,26.78,44.28,65.77,113.36,60.38a58,58,0,0,0,47.73-32.56L1342.51,868Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M686.26,1381.48c-22.3-90.84,203.62-293.35,203.62-293.35L835,890.4S347.18,1215.16,471.5,1476.33c17.82,37.44,41.49,63.66,68.93,81.2C579.71,1451.79,642.32,1403.3,686.26,1381.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M686.1,1368.25a5.33,5.33,0,0,1-5.17-4.07c-22.81-92.87,195.92-290.23,205.24-298.59a5.34,5.34,0,1,1,7.13,8c-2.24,2-223.3,201.4-202,288.1a5.34,5.34,0,0,1-3.92,6.46A5.53,5.53,0,0,1,686.1,1368.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1450.78,689.81s1.64,124.85-18.54,181.55-23.33,97.67-92.08,81.93S1230.84,883,1224.78,815.52c0,0-10.11-104.28,14.79-134.8S1450.78,689.81,1450.78,689.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1263.33,785l8.1,3.4s-4.64-82.45,29.73-82.17,160.46,25.36,202.82-5.33c40.84-29.59,40.84-89.95,14.63-117.85a4.68,4.68,0,0,0-6.33-.28l-4.8,3.94a4.72,4.72,0,0,1-7.68-4.2h0a4.69,4.69,0,0,0-7.3-4.46c-12.84,9.1-42,20.42-102,7.31-85.17-18.59-150.86-8.54-175.08,45.55a4.72,4.72,0,0,1-8.23.74c-4.35-6-13-11.6-29.87-6.34-29.37,9.14-40.36,60.21-9.13,119.13a4.7,4.7,0,0,1-3.14,6.89c-11,2-29.45,9.95-3.6,41.75,26.43,32.53,47.43,39,55.86,40.26a4.73,4.73,0,0,0,5.19-3.12l17.33-49.67a4.72,4.72,0,0,1,6.29-2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1261.07,796s10.78-74.79-27.4-68.58-16,82.14,7.22,94.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1165.68,1578.73q.64,0,1.29,0l562-.61a25.16,25.16,0,0,0,25.13-25.18c0-13.9-11.33-25.38-25.19-25.13l-562,.61a25.16,25.16,0,0,0-1.24,50.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2234.2,1068.47h-468a89.21,89.21,0,0,0-80.68,51.15L1469.1,1578.43h581.65a54.21,54.21,0,0,0,50.42-34.28L2269,1119.58A37.38,37.38,0,0,0,2234.2,1068.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1904.45,1303.71c-10.14,31.52-2.64,62.12,16.74,68.36s43.32-14.25,53.47-45.76,2.65-62.11-16.74-68.35S1914.6,1272.2,1904.45,1303.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1028.45,1373.66s-267.86,104-333.24,25.77a44.1,44.1,0,0,1-9-18c-43.94,21.82-106.55,70.31-145.83,176,140.88,90,381.68-50.08,446.79-91.38a48.62,48.62,0,0,1,36-6.61c25.12,5.21,68.5,12.87,91.9,9.27,34.23-5.28,83.39,115.46,138.87,78.22C1254,1547,1206.46,1337.16,1028.45,1373.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2256.13,2784.13a24.38,24.38,0,0,0,9.32-1.87,22.6,22.6,0,0,0,12.36-30L1782.51,1637.5c-5.16-11.6-19-17-31-12s-17.52,18.44-12.36,30l495.3,1114.72A23.66,23.66,0,0,0,2256.13,2784.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1698.14,2784.13a23.65,23.65,0,0,0,21.71-13.84l495.31-1114.72a22.6,22.6,0,0,0-12.37-30c-12-5-25.87.36-31,12L1676.46,2752.22a22.6,22.6,0,0,0,12.36,30A24.34,24.34,0,0,0,1698.14,2784.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M723,2784.13a24.38,24.38,0,0,0,9.32-1.87,22.6,22.6,0,0,0,12.36-30L249.32,1637.5c-5.15-11.6-19-17-31-12s-17.52,18.44-12.36,30l495.3,1114.72A23.66,23.66,0,0,0,723,2784.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M165,2784.13a23.64,23.64,0,0,0,21.7-13.84L682,1655.57a22.6,22.6,0,0,0-12.36-30c-12-5-25.87.36-31,12L143.28,2752.22a22.61,22.61,0,0,0,12.37,30A24.3,24.3,0,0,0,165,2784.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M106.87,1603.08a27.22,27.22,0,0,1,4.69-20.62,21.45,21.45,0,0,1,17.19-9.07H2382c8.74,0,16.89,5,21.6,13.24a31.73,31.73,0,0,1,1.68,27.52l-24.42,59.16c-5.59,13.55-17.71,22.23-31,22.23H144.21c-12.4,0-23.06-9.85-25.41-23.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2762.2,345.89c0,139-130.39,251.71-269.41,251.71s-251.71-112.69-251.71-251.71,112.7-251.71,251.71-251.71S2762.2,206.88,2762.2,345.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2707.14,345.89a206.69,206.69,0,0,1-281.35,192.6A206.3,206.3,0,0,1,2298.32,387.1a207.12,207.12,0,0,1,0-82.41,206.49,206.49,0,0,1,408.82,41.2Zm-27.53,0a169.08,169.08,0,0,0-3.59-33.95,163.86,163.86,0,0,0-10.59-32.51,169.46,169.46,0,0,0-40.16-55.64,179.54,179.54,0,0,0-59.28-36,184.45,184.45,0,0,0-68.51-11C2451,178,2406.31,197.34,2375,228.83a169.63,169.63,0,0,0-36.61,54.1,162.2,162.2,0,0,0,0,125.93A169.63,169.63,0,0,0,2375,463c31.34,31.49,76,50.84,122.51,52.05A184.45,184.45,0,0,0,2566,504a179.54,179.54,0,0,0,59.28-36,169.46,169.46,0,0,0,40.16-55.64A163.86,163.86,0,0,0,2676,379.85,169.1,169.1,0,0,0,2679.61,345.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2796,1506.57c0,139-130.39,251.71-269.41,251.71s-251.71-112.7-251.71-251.71,112.69-251.71,251.71-251.71S2796,1367.55,2796,1506.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2741,1506.57a206.69,206.69,0,0,1-281.35,192.59,206.3,206.3,0,0,1-127.47-151.39,207.12,207.12,0,0,1,0-82.41A206.49,206.49,0,0,1,2741,1506.57Zm-27.53,0a169,169,0,0,0-3.59-34,164,164,0,0,0-10.59-32.52,169.56,169.56,0,0,0-40.16-55.64,179.71,179.71,0,0,0-59.28-36,184.65,184.65,0,0,0-68.51-11c-46.5,1.21-91.18,20.56-122.51,52.06a169.32,169.32,0,0,0-36.61,54.09,162.23,162.23,0,0,0,0,125.94,169.32,169.32,0,0,0,36.61,54.09c31.33,31.5,76,50.84,122.51,52.06a184.85,184.85,0,0,0,68.51-11,179.87,179.87,0,0,0,59.28-36,169.56,169.56,0,0,0,40.16-55.64,164.16,164.16,0,0,0,10.59-32.52A169.08,169.08,0,0,0,2713.45,1506.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2477,1556.6l-50.63-1.09a3.18,3.18,0,0,1-3.1-3.17v-78.81a3.16,3.16,0,0,1,3.28-3.17l50.64,1.87a3.18,3.18,0,0,1,3,3.17v78A3.18,3.18,0,0,1,2477,1556.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2554.63,1558.21l-49.28-1a3.85,3.85,0,0,1-3.76-3.85V1436a3.85,3.85,0,0,1,4-3.85l49.28,2.1a3.85,3.85,0,0,1,3.68,3.85v116.25A3.84,3.84,0,0,1,2554.63,1558.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2630.28,1559.85l-46.28-1a4.16,4.16,0,0,1-4.08-4.16V1404.26a4.16,4.16,0,0,1,4.38-4.15l46.28,2.35a4.15,4.15,0,0,1,3.94,4.16v149.07A4.15,4.15,0,0,1,2630.28,1559.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2640.78,1595.16l-226.26-3.29a3.19,3.19,0,0,1-3.14-3.19v-12.77a3.19,3.19,0,0,1,3.25-3.2l226.25,4.06a3.2,3.2,0,0,1,3.14,3.2v12A3.2,3.2,0,0,1,2640.78,1595.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2422.34,511.24l-6.51,11a2.91,2.91,0,1,1-5-2.95l0,0,0-.06,6.54-10.85,0-.06a2.85,2.85,0,0,1,4.89,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2399.68,547.43,2392.36,558a3.11,3.11,0,1,1-5.1-3.55l0,0,0-.06,7.34-10.34,0-.05a3,3,0,0,1,5,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2374.44,581.88l-8,10a3.31,3.31,0,1,1-5.17-4.15l0,0,0,0,8-9.8,0-.05a3.25,3.25,0,0,1,5.05,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2347,614.52l-8.64,9.45a3.51,3.51,0,1,1-5.19-4.73l0,0,0-.05,8.64-9.27,0,0a3.45,3.45,0,0,1,5.08,4.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2317.54,645.43l-9.17,8.93a3.72,3.72,0,1,1-5.19-5.32l0,0,0,0,9.17-8.76,0,0a3.65,3.65,0,0,1,5.07,5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2286.39,674.61l-9.65,8.42a3.92,3.92,0,1,1-5.15-5.9l0,0,0,0,9.64-8.25,0,0a3.86,3.86,0,0,1,5,5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2253.73,702.1,2243.67,710a4.12,4.12,0,0,1-5.1-6.48l0,0,0,0,10-7.75,0,0a4.06,4.06,0,0,1,5,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2219.75,727.94l-10.43,7.43a4.32,4.32,0,0,1-5-7l0,0,0,0,10.4-7.26.05,0a4.26,4.26,0,0,1,4.91,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2184.6,752.14l-10.76,7a4.52,4.52,0,1,1-4.91-7.6l0,0,.05,0,10.72-6.78.05,0a4.46,4.46,0,0,1,4.81,7.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2148.38,774.74l-11.05,6.47a4.73,4.73,0,0,1-4.77-8.16l0,0,.05,0,11-6.3.05,0a4.66,4.66,0,0,1,4.67,8.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2111.22,795.75l-11.32,6a4.93,4.93,0,0,1-4.61-8.71l0,0,.06,0,11.26-5.83.06,0a4.87,4.87,0,0,1,4.51,8.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2073.2,815.17l-11.56,5.51a5.13,5.13,0,1,1-4.42-9.26l0,0,.06,0,11.5-5.35.06,0a5.07,5.07,0,0,1,4.32,9.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2034.39,833l-11.79,5a5.33,5.33,0,0,1-4.18-9.81l0,0,.06,0,11.71-4.86.06,0a5.27,5.27,0,0,1,4.09,9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1994.86,849.16l-12,4.53a5.54,5.54,0,1,1-3.91-10.36h0l.06,0,11.9-4.36.07,0a5.47,5.47,0,0,1,3.82,10.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1954.67,863.66l-12.18,4a5.74,5.74,0,1,1-3.59-10.9l0,0,.07,0,12.08-3.85.07,0a5.68,5.68,0,0,1,3.5,10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1913.87,876.4l-12.35,3.47a5.94,5.94,0,1,1-3.21-11.44h0l.08,0,12.22-3.31.08,0a5.88,5.88,0,0,1,3.13,11.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1872.51,887.3l-12.5,2.89a6.14,6.14,0,0,1-2.77-12h.06l.09,0,12.36-2.73.08,0a6.08,6.08,0,0,1,2.68,11.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1830.65,896.21,1818,898.48a6.34,6.34,0,1,1-2.23-12.49h0l.1,0,12.47-2.11.1,0a6.28,6.28,0,0,1,2.15,12.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2582.15,955.65l-12.73,0a4.6,4.6,0,1,1,0-9.19h0l12.74.11a4.57,4.57,0,0,1-.06,9.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2539.71,955.54H2527a4.7,4.7,0,0,1,0-9.4h0l12.74.07a4.67,4.67,0,0,1,0,9.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2497.25,955.55l-12.74,0a4.8,4.8,0,1,1,0-9.59h0l12.75,0a4.77,4.77,0,0,1,0,9.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2454.78,955.66l-12.74.06a4.9,4.9,0,1,1-.05-9.79h12.77a4.87,4.87,0,0,1,0,9.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2412.31,955.88l-12.74.08a5,5,0,0,1-.07-10h0l12.75,0a5,5,0,0,1,0,9.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2369.84,956.19l-12.75.11a5.1,5.1,0,0,1-.09-10.19h0l12.75-.05a5.07,5.07,0,0,1,.06,10.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2327.37,956.59l-12.75.13a5.2,5.2,0,1,1-.11-10.39h0l12.75-.07a5.17,5.17,0,0,1,.09,10.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2284.9,957.07l-12.75.16a5.3,5.3,0,0,1-.14-10.59h0l12.75-.1a5.27,5.27,0,0,1,.11,10.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2242.43,957.64l-12.75.19a5.4,5.4,0,0,1-.16-10.79h0l12.75-.13a5.37,5.37,0,0,1,.13,10.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2200,958.29l-12.74.22a5.5,5.5,0,0,1-.2-11h0l12.75-.15a5.46,5.46,0,0,1,.16,10.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2157.49,959l-12.74.24a5.6,5.6,0,0,1-.22-11.19h0l12.75-.18a5.57,5.57,0,0,1,.18,11.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2115,959.87l-12.74.27a5.69,5.69,0,1,1-.24-11.38h0l12.75-.2a5.66,5.66,0,0,1,.2,11.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2072.54,960.79l-12.74.3a5.79,5.79,0,0,1-.27-11.58h0l12.75-.24a5.76,5.76,0,0,1,.23,11.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2030.07,961.82l-12.74.33a5.89,5.89,0,0,1-.31-11.78h0l12.75-.27a5.86,5.86,0,0,1,.27,11.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1987.6,963l-12.74.36a6,6,0,1,1-.35-12h0l12.75-.3a6,6,0,0,1,.3,11.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1945.14,964.2l-12.74.4a6.09,6.09,0,1,1-.39-12.17h0l12.75-.34a6.06,6.06,0,0,1,.35,12.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1902.68,965.58l-12.74.45a6.19,6.19,0,0,1-.44-12.37h0l12.75-.39a6.16,6.16,0,0,1,.39,12.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1860.23,967.11l-12.73.49A6.28,6.28,0,1,1,1847,955h0l12.75-.43a6.25,6.25,0,0,1,.44,12.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1817.8,968.82l-6.9.29a6.37,6.37,0,0,1-.55-12.73h0l6.91-.27a6.36,6.36,0,0,1,.51,12.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2347.42,1474l-8.05-9.84,0,0a3.44,3.44,0,0,1,5.33-4.35l0,0,8,10a3.38,3.38,0,0,1-5.25,4.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2320.21,1441.46l-8.36-9.57,0,0a3.63,3.63,0,1,1,5.46-4.77l0,0,8.32,9.7a3.57,3.57,0,0,1-5.39,4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2292,1409.88l-8.67-9.3,0,0a3.82,3.82,0,1,1,5.58-5.21l0,0,8.64,9.42a3.76,3.76,0,0,1-5.52,5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2262.72,1379.23l-9-9,0,0a4,4,0,0,1,5.67-5.64l0,0,8.94,9.15a3.95,3.95,0,0,1-5.62,5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2232.51,1349.54l-9.25-8.71,0,0a4.18,4.18,0,1,1,5.74-6.09l0,0,9.23,8.85a4.13,4.13,0,0,1-5.69,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2201.36,1320.85l-9.52-8.41,0,0a4.37,4.37,0,1,1,5.79-6.56l0,0,9.51,8.55a4.32,4.32,0,0,1-5.75,6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2169.31,1293.17l-9.78-8.11,0,0a4.56,4.56,0,0,1,5.82-7l0,0,9.78,8.24a4.51,4.51,0,0,1-5.77,6.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2136.4,1266.53l-10-7.79,0,0a4.75,4.75,0,0,1,5.82-7.5l0,0,10,7.93a4.69,4.69,0,0,1-5.78,7.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2102.66,1241l-10.27-7.46,0,0a4.94,4.94,0,1,1,5.8-8l0,0,10.29,7.61a4.88,4.88,0,0,1-5.77,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2068.13,1216.46l-10.51-7.13,0,0a5.13,5.13,0,1,1,5.76-8.48l0,0,10.52,7.27a5.07,5.07,0,0,1-5.72,8.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2032.84,1193.09l-10.72-6.8,0,0a5.31,5.31,0,0,1,5.68-9l0,0,10.76,6.94a5.25,5.25,0,0,1-5.66,8.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1996.84,1170.85l-10.94-6.44-.05,0a5.5,5.5,0,0,1,5.58-9.47l0,0,11,6.6a5.44,5.44,0,0,1-5.57,9.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1960.14,1149.79,1949,1143.7l0,0a5.68,5.68,0,1,1,5.45-10l0,0,11.17,6.24a5.63,5.63,0,0,1-5.44,9.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1922.8,1129.91l-11.33-5.72,0,0a5.87,5.87,0,1,1,5.3-10.48l0,0,11.37,5.87a5.82,5.82,0,0,1-5.29,10.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1884.84,1111.26l-11.5-5.36-.06,0a6.06,6.06,0,0,1,5.12-11l0,0,11.56,5.51a6,6,0,0,1-5.12,10.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1846.3,1093.85l-11.67-5-.05,0a6.25,6.25,0,1,1,4.9-11.5l0,0,11.73,5.12a6.19,6.19,0,0,1-4.9,11.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2752.35,915.65c0,139-130.4,251.71-269.41,251.71s-251.71-112.7-251.71-251.71,112.69-251.71,251.71-251.71S2752.35,776.63,2752.35,915.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2697.29,915.65a206.69,206.69,0,0,1-281.35,192.59,206.3,206.3,0,0,1-127.47-151.39,206.64,206.64,0,0,1,0-82.41,206.49,206.49,0,0,1,408.82,41.21Zm-27.53,0a168.39,168.39,0,0,0-3.6-34,163.18,163.18,0,0,0-10.58-32.51,169.34,169.34,0,0,0-40.17-55.64,179.5,179.5,0,0,0-59.27-36,184.45,184.45,0,0,0-68.51-11c-46.5,1.21-91.18,20.56-122.51,52.05a169.47,169.47,0,0,0-36.61,54.1,162.2,162.2,0,0,0,0,125.93,169.47,169.47,0,0,0,36.61,54.1c31.33,31.49,76,50.84,122.51,52a184.45,184.45,0,0,0,68.51-11,179.5,179.5,0,0,0,59.27-36,169.34,169.34,0,0,0,40.17-55.64,163.18,163.18,0,0,0,10.58-32.51A168.37,168.37,0,0,0,2669.76,915.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2557.54,466.09H2424.07c-15.75,0-28.52-14.53-28.52-32.46V281.69c0-17.92,12.77-32.45,28.52-32.45h133.47c15.75,0,28.52,14.53,28.52,32.45V433.63C2586.06,451.56,2573.29,466.09,2557.54,466.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2519,312.73c0,17.63-12.55,36.65-28,36.65s-28-19-28-36.65,12.55-30.13,28-30.13S2519,295.11,2519,312.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2456.16,417.24h68.44c7.21,0,13.59-5.3,15.78-13.11l3.68-13.1c2.7-9.59-1.68-20-10-23.44-27.86-11.59-56.66-10.11-86.16,1.07-8.27,3.13-12.85,13.19-10.57,22.76l2.83,11.9C2442.13,411.54,2448.68,417.24,2456.16,417.24Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 2489.7,
    cy: 900.66,
    rx: 98.54,
    ry: 119.69,
    transform: "translate(1546.53 3374.57) rotate(-89.02)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 2483.22,
    cy: 893.55,
    rx: 93.93,
    ry: 78.84
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2520.77,901.13c0,8.71-.38,17.41-1.14,26.09a239,239,0,0,1-3.76,25.9,138.68,138.68,0,0,1-7.49,25.28,57.9,57.9,0,0,1-6.51,11.81,25.14,25.14,0,0,1-4.9,5,14.15,14.15,0,0,1-3.23,1.83,11,11,0,0,1-3.79.79,10.56,10.56,0,0,1-3.84-.62,13.84,13.84,0,0,1-3.3-1.74,23.86,23.86,0,0,1-5-5,55.88,55.88,0,0,1-6.6-11.77,136.16,136.16,0,0,1-7.56-25.26,270.6,270.6,0,0,1-5.18-52c0-8.7.45-17.4,1.19-26.08a258.14,258.14,0,0,1,3.52-25.92,140,140,0,0,1,7.08-25.34,54,54,0,0,1,6.33-11.83,22.35,22.35,0,0,1,4.88-5,12.85,12.85,0,0,1,3.24-1.71,10,10,0,0,1,3.73-.58,11.23,11.23,0,0,1,3.69.75,14.71,14.71,0,0,1,3.19,1.76,25.72,25.72,0,0,1,5,4.89,57.5,57.5,0,0,1,6.83,11.6,133.37,133.37,0,0,1,8.12,25.1,220.49,220.49,0,0,1,4.18,25.85C2520.3,883.72,2520.72,892.43,2520.77,901.13Zm-2.42,0c0-8.64-.32-17.29-1.12-25.91a223.77,223.77,0,0,0-3.72-25.72,130.66,130.66,0,0,0-7.53-25A55.47,55.47,0,0,0,2499.5,813a24.42,24.42,0,0,0-4.72-4.81,11.41,11.41,0,0,0-6.37-2.45A10.3,10.3,0,0,0,2482,808a21.24,21.24,0,0,0-4.6,4.87,53.11,53.11,0,0,0-6,11.72,138.52,138.52,0,0,0-6.49,25.23,299.13,299.13,0,0,0-3.7,51.75,269,269,0,0,0,4.39,51.66,135.08,135.08,0,0,0,7.12,25.07,53.44,53.44,0,0,0,6.27,11.55,21.82,21.82,0,0,0,4.65,4.75,10.22,10.22,0,0,0,6.25,2.17,9.47,9.47,0,0,0,3.28-.72,12.69,12.69,0,0,0,2.89-1.7,23.72,23.72,0,0,0,4.56-4.83,55.46,55.46,0,0,0,6.17-11.6,136.22,136.22,0,0,0,7-25.09,243.16,243.16,0,0,0,3.44-25.74C2518,918.43,2518.36,909.78,2518.35,901.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2570.18,901.13a113.78,113.78,0,0,1-5.12,33.3,101.8,101.8,0,0,1-15.78,30.51,87.33,87.33,0,0,1-26.8,23.51,75.53,75.53,0,0,1-17.22,7,72.63,72.63,0,0,1-18.71,2.46,74.65,74.65,0,0,1-36-9.39A87.17,87.17,0,0,1,2423.72,965a102.06,102.06,0,0,1-15.85-30.52A109,109,0,0,1,2404,918a117.19,117.19,0,0,1-1.29-16.83,118.53,118.53,0,0,1,1.31-16.82,108.37,108.37,0,0,1,3.87-16.51,102.1,102.1,0,0,1,15.88-30.49,87.12,87.12,0,0,1,26.87-23.44,73.26,73.26,0,0,1,71.75,0,87,87,0,0,1,26.79,23.45A101.94,101.94,0,0,1,2565,867.84,111.8,111.8,0,0,1,2570.18,901.13Zm-2.77,0a115.37,115.37,0,0,0-1.2-16.49,109.43,109.43,0,0,0-3.58-16.21,100.34,100.34,0,0,0-15-30.15,84.42,84.42,0,0,0-25.92-23.46,73.2,73.2,0,0,0-16.85-7,68.93,68.93,0,0,0-36.72,0,73.92,73.92,0,0,0-16.83,7,84.3,84.3,0,0,0-25.84,23.48,100.38,100.38,0,0,0-14.88,30.13,109.27,109.27,0,0,0-3.57,16.2,113.41,113.41,0,0,0-1.19,16.46,115,115,0,0,0,1.21,16.47,109.08,109.08,0,0,0,3.59,16.18,100,100,0,0,0,14.92,30.1,84.36,84.36,0,0,0,25.83,23.43,73.64,73.64,0,0,0,16.8,7,68.6,68.6,0,0,0,36.63,0,74.21,74.21,0,0,0,16.83-6.91,84.34,84.34,0,0,0,25.91-23.41,100.48,100.48,0,0,0,15-30.11A111.62,111.62,0,0,0,2567.41,901.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2389.61,862.87c8.31-.14,16.63-.19,24.94-.3l24.95-.16c8.32-.08,16.64-.07,24.95-.09l25-.05,24.95.06c8.32,0,16.63,0,25,.09l24.95.18c8.31.11,16.63.18,24.95.33a.12.12,0,0,1,.12.11.12.12,0,0,1-.12.1c-8.32.15-16.64.22-24.95.33l-24.95.18c-8.32.08-16.63.06-25,.09l-24.95.06-25,0c-8.31,0-16.63,0-24.95-.09l-24.95-.17c-8.31-.1-16.63-.16-24.94-.29a.18.18,0,0,1-.18-.17A.17.17,0,0,1,2389.61,862.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2418.55,825.75c5.9-.14,11.81-.2,17.71-.3l17.72-.17c11.8-.12,23.61-.13,35.42-.14s23.62,0,35.43.15l17.71.19c5.9.11,11.81.17,17.71.32a.11.11,0,0,1,.12.11c0,.06,0,.1-.12.11-5.9.14-11.81.21-17.71.32l-17.71.18c-11.81.12-23.62.14-35.43.16s-23.62,0-35.42-.14l-17.72-.17c-5.9-.1-11.81-.16-17.71-.3a.18.18,0,0,1-.18-.17A.17.17,0,0,1,2418.55,825.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2380.94,900c9-.14,18.07-.2,27.11-.3l27.12-.17c9-.07,18.08-.06,27.11-.08l27.12-.05,27.12.05c9,0,18.07,0,27.11.1l27.12.18c9,.11,18.08.17,27.12.32a.12.12,0,0,1,.12.11.13.13,0,0,1-.12.11c-9,.15-18.08.21-27.12.32l-27.12.19c-9,.08-18.07.06-27.11.09l-27.12.06-27.12,0c-9,0-18.07,0-27.11-.09l-27.12-.17c-9-.1-18.08-.16-27.11-.3a.16.16,0,1,1,0-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2389.61,937.13c8.31-.14,16.63-.2,24.94-.3l24.95-.17c8.32-.07,16.64-.06,24.95-.09l25-.05,24.95.06c8.32,0,16.63,0,25,.09l24.95.19c8.31.11,16.63.17,24.95.32a.12.12,0,0,1,.12.11.13.13,0,0,1-.12.11c-8.32.15-16.64.21-24.95.32l-24.95.18c-8.32.08-16.63.06-25,.1l-24.95,0-25,0c-8.31,0-16.63,0-24.95-.08l-24.95-.17c-8.31-.1-16.63-.16-24.94-.3a.16.16,0,1,1,0-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2563.82,975h-141.7a.57.57,0,1,1,0-1.13h141.7a.57.57,0,1,1,0,1.13Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImg4);
export default __webpack_public_path__ + "static/media/about_img_4.08d6180a166b006c83536ebfbacc5021.svg";
export { ForwardRef as ReactComponent };